import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=fe47b1e0&"
import script from "../../../services/applicant/home/policy.js?vue&type=script&lang=js&"
export * from "../../../services/applicant/home/policy.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports